/**
 * Machine Widgets Registry
 * Central export point for all widget components
 */

import InfoListWidget from './InfoListWidget';
import MetricGridWidget from './MetricGridWidget';
import ProgressBarWidget from './ProgressBarWidget';
import DocumentCardWidget from './DocumentCardWidget';
import DateInfoWidget from './DateInfoWidget';
import ChartWidget from './ChartWidget';
import DataTableWidget from './DataTableWidget';
import TimelineWidget from './TimelineWidget';
import ImageCardWidget from './ImageCardWidget';
import SectionRenderer, { Section } from './SectionRenderer';

/**
 * Widget Registry
 * Maps widget type strings to their component implementations
 * 
 * Phase 1-3: info_list, metric_grid, progress_bar, document_card, date_info
 * Phase 4:   chart, data_table, timeline, image_card
 */
export const WIDGET_REGISTRY = {
  // Phase 1-3 widgets
  info_list: InfoListWidget,
  metric_grid: MetricGridWidget,
  progress_bar: ProgressBarWidget,
  document_card: DocumentCardWidget,
  date_info: DateInfoWidget,
  // Phase 4 widgets
  chart: ChartWidget,
  data_table: DataTableWidget,
  timeline: TimelineWidget,
  image_card: ImageCardWidget,
};

/**
 * Get widget component by type
 * @param {string} type - Widget type identifier
 * @returns {React.Component|null} Widget component or null if not found
 */
export const getWidget = (type) => WIDGET_REGISTRY[type] || null;

/**
 * Get all available widget types
 * @returns {string[]} Array of widget type names
 */
export const getWidgetTypes = () => Object.keys(WIDGET_REGISTRY);

// Named exports for direct imports
export {
  InfoListWidget,
  MetricGridWidget,
  ProgressBarWidget,
  DocumentCardWidget,
  DateInfoWidget,
  ChartWidget,
  DataTableWidget,
  TimelineWidget,
  ImageCardWidget,
  SectionRenderer,
  Section,
};

// Utility exports
export * from './utils';
